module.exports = __webpack_public_path__ + "static/media/Room4.69887571.PNG";